export const upsertById = <T extends { id: string }>(list: T[], entries: T | T[]): void => {
    for (const entry of Array.isArray(entries) ? entries : [entries]) {
        const at = list.findIndex((item) => item.id === entry.id);
        if (at >= 0) list[at] = entry; else list.push(entry);
    }
};

export const dropById = <T extends { id: string }>(list: T[], id: string): void => {
    const at = list.findIndex((item) => item.id === id);
    if (at >= 0) list.splice(at, 1);
};
